export const MAX_VIN_LENGTH = 17;
export const MAX_REGISTRATION_NUMBER_LENGTH = 15;
export const MAX_FIN_CODE_LENGTH = 20;
export const MAX_COMPANY_NAME_LENGTH = 200;
export const MAX_EMAIL_LENGTH = 235;
export const MAX_CONTACT_NAME_LENGTH = 200;

// 6.03.2024 1PM CET
export const FNP_APPLICATION_VERSION = 7.0;